module.exports = __webpack_public_path__ + "media/src/images/partners/udima-c21ec67acea0a6040f274efc3d449339.jpg";